import { render } from "./UpdateModal.vue?vue&type=template&id=b0e264c2&scoped=true"
import script from "./UpdateModal.vue?vue&type=script&lang=js"
export * from "./UpdateModal.vue?vue&type=script&lang=js"

import "./UpdateModal.vue?vue&type=style&index=0&id=b0e264c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0e264c2"]])

export default __exports__